export default "__VITE_ASSET__39Let0Mh__"